import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { BudgetUseExtendedListResponse, BudgetUseExtendedQueryParams } from '@frontend/budget/types';

export class BudgetUseExtendedClient extends APIClient {
    public static readonly endpoint = '/budget-api/ext/v1';

    public static async fetchExtendedBudgetUses(queryParams?: ApiQueryParams<BudgetUseExtendedQueryParams>): Promise<BudgetUseExtendedListResponse> {
        return this.apiPaginated<BudgetUseExtendedListResponse, BudgetUseExtendedQueryParams>(`${this.endpoint}/budget-uses`, queryParams);
    }
}
